'use client';

import { LOGIN_QUERY_PARAMS, URL_PARAMS } from "@/lib/consts/params";
import { getQueryParam, getUrlParam } from "@/lib/utils/url";
import { featureFlagService } from "@/lib/services/featureFlag";
import { FeatureFlags } from "@/lib/consts/featureFlags";
import sessionService from "@/lib/services/session";

export const getRedirectFromPortalLoginToken = () => {
    const redirectLoginToken = getQueryParam(LOGIN_QUERY_PARAMS.REDIRECT_LOGIN_TOKEN, window.location.search);
    return redirectLoginToken;
}

export const isJwtTokenLogin = () => {
    return featureFlagService.isEnabled(FeatureFlags.CHECKOUT_LINKS_USE_DYNAMO_JWT) && getUrlParam(URL_PARAMS.JWT_PARAM);
}

export const isSessionDataLogin = () => {
    const sessionToken = sessionService.getSessionToken();
    return Boolean(sessionToken);
}

export const isAutoLoginFlow = (): boolean => {
    return Boolean(getRedirectFromPortalLoginToken()) ||
           Boolean(isJwtTokenLogin()) ||
           isSessionDataLogin();
}